import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, ref } from "vue";
import { useField } from "vee-validate";
import { useSlots } from "vue";
//@ts-ignore
import BaseInput from "@/components/form/_base.vue";

interface Props {
    value?: string | number | boolean;
    name: string;
    label: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    value: { type: [String, Number, Boolean], required: false, default: undefined },
    name: { type: String, required: true, default: undefined },
    label: { type: String, required: true, default: undefined }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { value: string | number | boolean, name: string, label: string }



const slots = useSlots();
const hasSlot = (name: string) => !!slots[name];

const { handleChange, errorMessage, meta } = useField(ref(props.name), undefined, { type: "radio", checkedValue: props.value });
const uid = getCurrentInstance()?.uid;

const __returned__ = { props, slots, hasSlot, handleChange, errorMessage, meta, uid, BaseInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})